import React from 'react';
import { Link } from 'react-router-dom';
import { getColors } from '../theme';
import { useApp } from '../context/AppContext';

const Footer = () => {
  const { isDark } = useApp();
  const colors = getColors(isDark);

  return (
    <footer 
      className="mt-8 pt-8 pb-4 border-t"
      style={{ borderColor: colors.border }}
    >
      <div className="text-center">
        <div className="flex items-center justify-center gap-6 text-xs">
          <Link 
            to="/about" 
            className="underline hover:opacity-70 transition-opacity"
            style={{ color: colors.textMuted }}
          >
            About
          </Link>
          <Link 
            to="/privacy" 
            className="underline hover:opacity-70 transition-opacity"
            style={{ color: colors.textMuted }}
          >
            Privacy Policy
          </Link>
          <Link 
            to="/terms" 
            className="underline hover:opacity-70 transition-opacity"
            style={{ color: colors.textMuted }}
          >
            Terms of Service
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
